import {IncomingInvoice} from '../api/dtos/dtos';
import * as React from 'react';
import {CSSProperties} from 'react';
import {IncomingInvoiceState} from './incoming-invoice-state';
import * as moment from 'moment';
import {toMomentOrThrow} from '../utils/date-utils';
import {Icon} from 'antd';
import locales from '../locales';

export const isIncomingInvoiceOverdue = (invoice: IncomingInvoice) => {
  return invoice.state !== IncomingInvoiceState.TRANSFERRED && moment().isAfter(toMomentOrThrow(invoice.paymentDeadline));
};

export const renderOverdueIcon = () => {
  const iconStyle: CSSProperties = {
    // Note: this changes the internal svg icon size as well
    fontSize: 16,
    color: '#f04134'
  };
  return <Icon type="warning" theme="filled" style={iconStyle} title={locales.overdue}/>
};


// WEBPACK FOOTER //
// ./src/incoming-invoices/incoming-invoice-overdue.tsx